import { ShippingCoverageZodSchema } from "@redotech/redo-conversion-core-common/redo-in-shipping/ris";
import { ShopifyExchangePaymentStrategy } from "@redotech/redo-shopify-common/shopify";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export interface UpdateShopifyIntegrationSettingsDef {
  name: "updateShopifyIntegrationSettings";
  input: z.ZodObject<{
    teamId: z.ZodType<string>;
    integrationType: z.ZodString;
    integration: z.ZodNullable<typeof ShippingCoverageZodSchema>;
    exchangePaymentStrategy: z.ZodOptional<
      z.ZodType<ShopifyExchangePaymentStrategy>
    >;
  }>;
  output: z.ZodNullable<typeof ShippingCoverageZodSchema>;
}

export const updateShopifyIntegrationSettings: UpdateShopifyIntegrationSettingsDef =
  {
    name: "updateShopifyIntegrationSettings" as const,
    input: z.object({
      teamId: zExt.objectId(),
      integrationType: z.string(),
      integration: ShippingCoverageZodSchema.nullable(),
      exchangePaymentStrategy: z
        .nativeEnum(ShopifyExchangePaymentStrategy)
        .optional(),
    }),
    output: ShippingCoverageZodSchema.nullable(),
  };
